module.exports = __webpack_public_path__ + "4692eae36a03ac06ebc1fd3ea4266857.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-preppy-s.png
// module id = 1967
// module chunks = 0